import axios, { AxiosResponse } from "axios"
import { Service } from "../services/Service"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL

class ModuleApi {
    /**
     * Donne la liste de tous les Modules disponibles, et les groupe par permission.
     * @returns Promise<Array<{_id: stringdisplayName: stringrefs: Array<{ permissionLevel: number; id: string }>}>
     */
    public static async getAllModules(): Promise<
        Array<{
            _id: string
            displayName: string
            refs: Array<{ permissionLevel: number; id: string }>
        }>
    > {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(`${serverBaseURL}/modules/list`, {
            headers,
        })
        return response.data
    }

    /**
    Donne tous les modules disponibles pour un admin
     */
    public static async getAdminModules(): Promise<Array<any>> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(`${serverBaseURL}/modules/admin`, {
            headers,
        })
        return response.data
    }

    /**
     * Donne la liste de modules dont l'user à droit
     * @param userId user id
     */
    public static async getAllModulesByUser(userId: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/modules?user=${userId}`,
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return undefined
    }

    /**
     * Met à jour les modules dont l'admin du groupe à droit
     * @param userId user id (doit etre un admin)
     * @param moduleIds liste des ids des id des modules qu'on attribut à l'admin
     */
    public static async updateModulesByUser(
        userId: string,
        moduleIds: Array<string>
    ): Promise<AxiosResponse<string>> {
        const headers = await Service.getRequestHeaders()
        return axios.patch(
            `${serverBaseURL}/modules/user/${userId}`,
            moduleIds,
            {
                headers,
            }
        )
    }
}
export default ModuleApi
